import { render, staticRenderFns } from "./GestioneMessaggi.vue?vue&type=template&id=932319a8&"
import script from "./GestioneMessaggi.vue?vue&type=script&lang=js&"
export * from "./GestioneMessaggi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports